<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <company-bank-accounts-create-or-update v-model="account" :errors="errors"></company-bank-accounts-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BankOprationsApi from '@/api/bank';
import CompanyBankAccountsCreateOrUpdate from './components/CompanyBankAccountsCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        CompanyBankAccountsCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Banka",key:"Bank.BankName", thClass:"w-15"},
                {name:"Hesap Adı",key:"Name", thClass:"w-25"},
                {name:"Hesap Numarası",key:"AccountNumber", thClass:"w-10"},
                {name:"Banka Şube Kodu",key:"BranchNumber", thClass:"w-10"},
                {name:"Açıklama Tipi",key:"DescriptionType", thClass:"w-40"},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            account:{
                Id:null,
                Name:null,
                BankId:null,
                AccountNumber:null,
                BranchNumber:null,
                DescriptionTypeId:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.account.Id = null
            this.account.Name = null
            this.account.BankId = null
            this.account.AccountNumber = null
            this.account.BranchNumber = null
            this.account.DescriptionTypeId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return BankOprationsApi.CompanyBankAccount.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.account.Id = item.Id
            this.account.Name = item.Name
            this.account.BankId = item.Bank?.Id || null
            this.account.DescriptionTypeId = item.DescriptionTypeId ?? null
            this.account.AccountNumber = item.AccountNumber
            this.account.BranchNumber = item.BranchNumber || null
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            BankOprationsApi.CompanyBankAccount.CreateOrUpdate(this.editing,this.account).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Bank.BankName} bankasındaki ${item.AccountNumber} numaralı hesabı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    BankOprationsApi.CompanyBankAccount.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>
